module.exports = __webpack_public_path__ + "static/img/zixun.94873ee.jpg";


//////////////////
// WEBPACK FOOTER
// ./static/img/zixun.jpg
// module id = j0Pq
// module chunks = 1